import { render, staticRenderFns } from "./PanelBluePlayerInfo.vue?vue&type=template&id=bf325fd8&"
import script from "./PanelBluePlayerInfo.vue?vue&type=script&lang=js&"
export * from "./PanelBluePlayerInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports